import { render, staticRenderFns } from "./CustomDatepicker.vue?vue&type=template&id=0893d3e4&scoped=true&"
import script from "./CustomDatepicker.vue?vue&type=script&lang=ts&"
export * from "./CustomDatepicker.vue?vue&type=script&lang=ts&"
import style0 from "./CustomDatepicker.vue?vue&type=style&index=0&id=0893d3e4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0893d3e4",
  null
  
)

export default component.exports